export const formatCurrency = (amount?: number) => {
    if (amount == null) return "--";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(amount);
};
